import React, { useEffect, useState } from 'react'
import Dropdown from '../../../DropDown/Dropdown'
import ReportsUploader from '../../../ReportsUploader/ReportsUploader'
import './choosedoctor.css'
import { useSelector, useDispatch } from "react-redux";
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import moment from 'moment'
import {
    fetch_clinic_speciality,
    fetch_clinic_speciality_doctor_list,
    insert_inter_branch,
    fetch_patients_details,
    fetch_services,
    Store_formData,
    book_appointment,
    show_common_alert, book_Videoconsultaton

} from "../../../../actions/InterBranchCoordinatorAction"
import { fetch_appointmentSlot } from "../../../../actions/AppointmentSlotAction";
import { DatePicker, Form, TimePicker } from 'antd';
import { fetchTypeofAppoinment } from "../../../../actions/ReasonforVisitAction";
import checkImage from '../../../../assets/InterBranch/PNGIcons/check.png'
import { PulseLoader } from 'react-spinners';
import { SimpleCloseIconRed } from '../../../../assets/Logos/Icons';
import { convertDateToString } from '../../../../Helpers/dateFunctions';
import { INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM, INTERBRANCH_MODAL_UPDATE, INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM, INTERBRANCH_UPLOAD_REPORTS_UPDATE } from '../../../../actions/type';

function ChooseDoctor() {

    let history = useHistory()
    let dispatch = useDispatch()
    let clinicId = useSelector((state) => state?.login?.user?.clinicId);
    let partnerId = useSelector((state) => state?.login?.user?.userId);
    let { path, url } = useRouteMatch();


    //We van controle the form using form this useForm hook.  "form" this is the instance name.
    const [form] = Form.useForm();

    let reduxData = useSelector(state => state);
    console.log("Redux data in Choose Dr:", reduxData)
    let specialities = reduxData?.interBranchCoordinator?.interBranchClinicSpeciality?.data;

    let specialityDoctors = reduxData?.interBranchCoordinator?.interBranchClinicSpecialityDoctorList?.data;

    let patientId = reduxData?.interBranchCoordinator?.interBranchRegisterPatient?.data?.info;

    let typeOfConsultation = reduxData?.bookAppoinment?.typeofAppoinment;

    let couponStatusRedux = reduxData?.interBranchCoordinator?.interBranchCouponStatus?.data?.info;

    let appointmentBookStatus = reduxData?.interBranchCoordinator?.interBranchAppointmentBookStatus

    const localReportsUploaded = useSelector((state) => state?.interBranchCoordinator?.temp_appointment_form?.reportsUploaded)

    let userDetails = JSON.parse(localStorage.getItem("userData"));
    const userId = userDetails.profileId;

    let appointment_form = useSelector(state => state?.interBranchCoordinator?.appointment_form)
    let temp_appointment_form = useSelector(state => state?.interBranchCoordinator?.temp_appointment_form)

    let typeOfConsultationBooked = reduxData?.interBranchCoordinator?.appointment_form?.typeOfConsultation;
    let couponCodeBooked = reduxData?.interBranchCoordinator?.appointment_form?.couponCode;
    let patientNumber = reduxData?.interBranchCoordinator?.appointment_form?.patientNumber?.numberWithCode;
    let { specialisation, chosendoctorId, patientHospitalId, chosenDate } = reduxData?.interBranchCoordinator?.appointment_form;

    let { timeSlot } = useSelector(state => state?.doctorDetail)

    const [chosenSpeciality, setChosenSpeciality] = useState(null);
    const [chosenDoctorId, setChosenDoctorId] = useState(chosendoctorId);
    const [chosenTypeOfConsultation, setChosenTypeOfConsultation] = useState(null);
    const [couponCode, setCouponCode] = useState(null);
    const [selectedTime, setSelectedTime] = useState(null);

    const [buttonClicked, setButtonClicked] = useState(null);
    const [isCouponVerified, setIsCouponVerified] = useState(false);
    let [isCouponVerifiying, setCouponVerifiying] = useState(false)
    let [isFilled, setFilled] = useState(false);
    let [isCouponChanged, setCouponChanged] = useState(false)
    let [couponStatus, setCouponStatus] = useState(couponStatusRedux)
    let [isDrLoading, setDrLoading] = useState(false)
    const [selecteddate, setSelectedDate] = useState("")


    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    useEffect(() => {

        try {
            dispatch(fetch_clinic_speciality(clinicId)).then(() => {

                loadDefaultValues()

            });


        } catch (error) {
            //console.log("Error in fetch_clinic_speciality API", error);
        }
        loadReportsUploadedToLocalForm()

        return () => {
            dispatch({
                type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
            })
        }
    }, [])


    useEffect(() => {

        setDrLoading(true)
        try {
            if (chosenSpeciality) {
                //Reset field value by assigning undefined or change value by giving direct value to "doctorId (Form item name)" 


                form.setFieldsValue({ doctorId: undefined });
                form.setFieldsValue({ typeOfConsultation: undefined });
                form.setFieldsValue({ time: undefined });
                form.setFieldsValue({ date: "" });

                dispatch(fetch_clinic_speciality_doctor_list(clinicId, chosenSpeciality)).then(() => {
                    setDrLoading(false)
                    if (appointment_form.chosendoctorId && chosenSpeciality == appointment_form.specialisation) {
                        form.setFieldsValue({ doctorId: appointment_form.chosendoctorId });
                    }
                    if (appointment_form.typeOfConsultation && chosenSpeciality == appointment_form.specialisation) {
                        form.setFieldsValue({ typeOfConsultation: appointment_form.typeOfConsultation });
                    }
                    if (appointment_form.typeOfConsultation && appointment_form.chosendoctorId && chosenSpeciality == appointment_form.specialisation) {
                        form.setFieldsValue({ date: appointment_form.chosenDate });
                        form.setFieldsValue({ time: appointment_form.chosenTime });
                    }
                })
            }
            else {
                setDrLoading(false)
            }



        } catch (error) {
            setDrLoading(false)
            //console.log("Error in fetch_clinic_speciality_doctor_list API", error);
        }
    }, [chosenSpeciality])

    useEffect(() => {
        try {
            if (chosenDoctorId) {
                //Reset Type of consultation if Doctor id changes            
                form.setFieldsValue({ typeOfConsultation: undefined });
                // form.setFieldsValue({ date: moment(new Date()) });
                form.setFieldsValue({ date: "" });
                form.setFieldsValue({ time: undefined });
            }
            dispatch(fetchTypeofAppoinment(chosenDoctorId))
        } catch (error) {
            //console.log("Error in fetchTypeofAppoinment API", error);
        }


    }, [chosenDoctorId])


    useEffect(() => {
        if (chosenTypeOfConsultation) {
            form.setFieldsValue({ date: "" });
            form.setFieldsValue({ time: undefined });
        }

        if (selecteddate) {
            getTimeSlots(selecteddate)
        }

        // getTimeSlots(moment(new Date()))
    }, [chosenTypeOfConsultation])

    useEffect(() => {
        if (selecteddate) {
            form.setFieldsValue({ time: undefined });
        }
        getTimeSlots(selecteddate)
    }, [selecteddate])

    useEffect(() => {
        setCouponStatus(couponStatusRedux)
    }, [couponStatusRedux])

    useEffect(() => {
        setChosenSpeciality(appointment_form?.specialisation)
        setChosenDoctorId(appointment_form?.chosendoctorId)
        setChosenTypeOfConsultation(typeOfConsultationBooked)
        setCouponCode(appointment_form?.couponCode)
        setSelectedDate(appointment_form?.chosenDate)
        setSelectedTime(appointment_form?.chosenTime)

    }, [appointment_form])


    let verifyCoupon = (couponCode) => {

        setCouponChanged(false)
        setCouponVerifiying(true)
        //console.log("Verifying coupon code...............................");
        try {
            dispatch(fetch_services(couponCode, userId))
                .then((res) => {
                    //console.log("Printing response of coupon verification==>: ", res)
                    setCouponVerifiying(false)
                });
        } catch (error) {
            //console.l  return trueog("Error in services API", error);
            setCouponVerifiying(false)
            setCouponChanged(false)
        }
    }

    let convertSpecialitiesForDropDown = (specility_list) => {



        let result = []

        if (specility_list && specility_list.length > 0) {
            specility_list.map((element, key) => { result.push({ option: element.specialityName, value: element.specialityName }) })

        }
        return result;

    }

    let convertDoctorNamesForDropDown = (doctor_list) => {

        let dropdownOptions = []



        if (doctor_list && doctor_list.length > 0) {

            doctor_list.map((eachItem) => {

                let id = Object.keys(eachItem)[0]
                let name = Object.values(eachItem)[0]
                dropdownOptions.push({ option: name, value: id, status: eachItem.loginstatus })


            })

        }

        //console.log("Converting dr name......................................",specialityDoctors);
        return dropdownOptions;
    }

    let convertTypeOfConsultationForDropDown = (type_list) => {
        let result = [];
        if (type_list && type_list.length > 0) {
            type_list.map((element, key) => { result.push({ option: element.Type, value: element.Type }) })
        }
        return result;

    }

    let convertTimesForDropDown = (timesList) => {

        let indexdate = moment(selecteddate).format("D-M-YYYY")

        let filterList = timesList.filter((each) => each.date == indexdate)[0]

        console.log(indexdate, filterList);

        let result = [];
        if (filterList && filterList.slots && filterList.slots.length > 0) {
            filterList.slots.map((element, key) => { result.push({ option: element.time, value: element.time }) })
        }
        return result;

    }

    let getTimeSlots = (e) => {

        setSelectedDate(e)
        console.log("date e._d:", e._d, "selecteddate:", selecteddate)
        dispatch(fetch_appointmentSlot({
            isStart: true,
            isNext: false,
            date: e._d,//selecteddate,
            typeofconsultation: chosenTypeOfConsultation,
            doctorId: chosenDoctorId
        }
        ))
            .then((res) => {
                console.log("Slots: ", res)
            })
    }

    const onFinish = (values) => {


        let submissiondata = {
            specialisation: values?.specialisation,
            chosendoctorId: values?.doctorId,
            typeOfConsultation: values?.typeOfConsultation,
            couponCode: values?.couponCode,
            reportsUploaded: localReportsUploaded ? localReportsUploaded : []
        }



        if (url.includes("scheduleappointment")) {
            submissiondata['chosenDate'] = values?.date
            submissiondata['chosenTime'] = values?.time
        }


        dispatch(
            Store_formData({
                ...submissiondata
            })
        )

        try {
            dispatch(fetch_patients_details(chosendoctorId, patientId, appointment_form, submissiondata)).then((res) => {
                console.log("Fetched patient details", res)
            })
        } catch (error) {
            //console.log("Error in fetch_patients_details API", error);
        }

        if (buttonClicked === "Review") {
            // try {
            //     dispatch(fetch_patients_details(chosendoctorId, patientId, appointment_form, submissiondata)).then((res) => {

            history.push(`/dashboard/${url.includes("bookandconsult") ? "bookandconsult" : "scheduleappointment"}/patientmedical`)

            dispatch({
                type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
            })
            //     })
            // } catch (error) {
            //     console.log("Error in fetch_patients_details API", error);
            // }

        }
        if (buttonClicked === "Join") {

            //console.log("Join Clicked - Inserting data into interbranch");
            try {
                try {
                    dispatch(book_Videoconsultaton(patientId, userId, chosenDoctorId, chosenTypeOfConsultation, couponCode, selectedTime, selecteddate, appointment_form)).
                        then((res) => {

                            if (res.data.appointmentId != "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience.") {

                                localStorage.setItem("AppointmentId", res.data.appointmentId)
                                history.push("/joinconsultation/"+res.data.appointmentId);
                                dispatch({
                                    type: INTERBRANCH_CLEAR_TEMP_APPOINTMENT_FORM,
                                })
                            }

                        })
                } catch (error) {
                    //console.log("Error in book_appointment API", error);
                }
            } catch (error) {

            }

        }



    };


    const onFinishFailed = (errorInfo) => {
        //console.log('Failed:', errorInfo);
    };


    let renderCoupon = () => {



        if (isCouponVerifiying) {

            return (
                <div className="verify-btn">
                    <PulseLoader color='#0a8ce0' size={6} />
                </div>
            )

        }

        else if ((couponCode && !couponStatusRedux && !isCouponVerifiying) || isCouponChanged && couponCode) {
            return <div className="verify-btn" onClick={() => verifyCoupon(couponCode)}>VERIFY</div>
        }

        else if (couponCode && couponStatusRedux == "No such coupon" && !isCouponVerifiying) {
            return (
                <div className="couponerror">
                    {/* <img src={checkImage} alt="" /> */}
                    <SimpleCloseIconRed />
                    <span style={{ marginLeft: "5px" }}> Invalid Coupon</span>
                </div>
            )
        }


        else if (couponCode && couponStatusRedux == "Success" && !isCouponVerifiying) {
            return (
                <div className="couponsuccess">
                    <img src={checkImage} alt="" />
                    {couponStatusRedux}
                </div>
            )
        }
        else {
            <div></div>
        }

    }

    let isCouponCodeVerified = () => {

        if (couponStatusRedux == "Success" && !isCouponChanged && !isCouponVerifiying) {
            return true
        }
    }

    let isScheduled = () => {

        return url.includes("scheduleappointment")

    }

    let handleSubmit = () => {


        setButtonClicked("Review")
    }

    let bookappointment = () => {
        try {
            dispatch(book_appointment(patientId, userId, chosenDoctorId, chosenTypeOfConsultation, couponCode, selectedTime, selecteddate, temp_appointment_form)).
                then((res) => {

                    if (res?.status) {

                        dispatch(show_common_alert({ message: "Appointment Booked Successfully" }))
                    }
                })
        } catch (error) {
            //console.log("Error in book_appointment API", error);
        }
    }

    const loadDefaultValues = () => {

        console.log("default...............", appointment_form);

    }

    let JoinNow = () => {
        try {
            try {
                dispatch(book_Videoconsultaton(patientId, userId, chosenDoctorId, chosenTypeOfConsultation, couponCode, selectedTime, selecteddate, appointment_form)).
                    then((res) => {


                    })
            } catch (error) {
                //console.log("Error in book_appointment API", error);
            }
        } catch (error) {

        }
        //  history.push("/joinconsultation");
    }


    const onValuesChange = (values) => {
        dispatch({
            type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM,
            payload: { ...values }
        })
    }

    const isBookAppointmentDisabled = () => {

        if (appointmentBookStatus) {

            return true

        }
        else {
            if (couponStatusRedux == "Success" && !isCouponChanged && !isCouponVerifiying) {
                return false
            }
            else {
                return true
            }
        }

    }


    const loadReportsUploadedToLocalForm = () => {

        let reportTobeLoaded = appointment_form?.reportsUploaded

        if (reportTobeLoaded && reportTobeLoaded.length > 0) {
            dispatch({ type: INTERBRANCH_UPLOAD_REPORTS_UPDATE, payload: reportTobeLoaded });
        }

    }


    return (
        <div className='choose-doctor-container'>

            <div className="tittle">Doctor Details
                <div className="details-item mandatory">

                    <div className="caption-mandatory"> <span className="red">*</span>  Mandatory</div>

                </div>
            </div>

            <Form
                form={form}
                name="basic"
                labelCol={{
                    span: 8,
                }}
                wrapperCol={{
                    span: 16,
                }}
                initialValues={{
                    remember: true,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                onValuesChange={onValuesChange}
                autoComplete="off"
            >

                <div className="details-item mandatory">

                    <div className="caption">Specialisation<div className="red">*</div></div>
                    <div className="input-item ">

                        <Form.Item

                            name="specialisation"
                            initialValue={appointment_form.specialisation ? appointment_form.specialisation : undefined}
                            rules={[
                                {
                                    required: true,
                                    message: '*Please select specialisation',
                                },
                            ]}
                        >
                            <Dropdown
                                width={300}
                                data={convertSpecialitiesForDropDown(specialities)}
                                onChange={(e) => {
                                    setChosenSpeciality(e);
                                    convertDoctorNamesForDropDown(null);
                                }}
                                placeholder="Select"
                            />

                        </Form.Item>

                    </div>


                </div>

                <div className="details-item mandatory">

                    <div className="caption">Doctor Name <div className="red">*</div></div>
                    <div className="input-item ">
                        <Form.Item
                            name="doctorId"
                            initialValue={appointment_form?.chosendoctorId ? appointment_form.chosendoctorId : undefined}
                            rules={[
                                {
                                    required: true,
                                    message: '*Please select doctor name',
                                },
                            ]}
                        >
                            <Dropdown
                                haveStatus
                                width={300}
                                loading={isDrLoading}
                                data={convertDoctorNamesForDropDown(specialityDoctors)}
                                onChange={(e) => setChosenDoctorId(e)}


                                placeholder="Select"
                            />


                        </Form.Item>

                    </div>
                    <div className='dorctor-status-info-container'>

                        <div className="info-item info-item-online">
                            <div className="info-color"></div>
                            <div className="info-caption">Online</div>
                        </div>

                        <div className="info-item info-item-offline">
                            <div className="info-color"></div>
                            <div className="info-caption">Offline</div>
                        </div>

                    </div>

                </div>

                <div className="details-item mandatory">

                    <div className="caption">Type of Consultation <div className="red">*</div></div>
                    <div className="input-item " style={{ textTransform: "capitalize" }}>
                        <Form.Item
                            initialValue={typeOfConsultationBooked ? typeOfConsultationBooked : undefined}
                            name="typeOfConsultation"
                            rules={[
                                {
                                    required: true,
                                    message: '*Please select type of consultation',
                                },
                            ]}
                        >
                            <Dropdown
                                width={300}
                                data={convertTypeOfConsultationForDropDown(typeOfConsultation)}
                                onChange={(e) => setChosenTypeOfConsultation(e)}
                                placeholder="Select"
                            />

                        </Form.Item>
                    </div>


                </div>

                {
                    isScheduled() &&
                    <>
                        <div className="details-item mandatory">

                            <div className="caption">Appointment Date <div className="red">*</div></div>
                            <div className="input-item">

                                <Form.Item
                                    name="date"
                                    // initialValue={moment(chosenDate ? chosenDate : "")}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select date',
                                        }
                                    ]}
                                >

                                    <DatePicker
                                        value={moment(chosenDate ? chosenDate : "")}
                                        className='input'
                                        style={{ width: "100% !important" }}
                                        format="DD-MM-YYYY"
                                        placeholder="DD-MM-YYYY"
                                        disabledDate={(current) => {
                                            return current < moment().subtract(1, 'day');
                                        }}
                                        // onSelect={getTimeSlots}
                                        onSelect={(e) => { setSelectedDate(convertDateToString(e)); getTimeSlots(e) }}
                                    // defaultValue={moment(new Date())} 
                                    />



                                </Form.Item>


                            </div>


                        </div>

                        <div className="details-item mandatory">

                            <div className="caption">Appointment Time <div className="red">*</div></div>
                            <div className="input-item">

                                <Form.Item
                                    name="time"
                                    initialValue={appointment_form?.chosenTime ? appointment_form.chosenTime : undefined}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please select time',
                                        }
                                    ]}
                                >

                                    <Dropdown
                                        width={300}
                                        data={convertTimesForDropDown(timeSlot)}
                                        onChange={(e) => setSelectedTime(e)}
                                        placeholder="Select"
                                    />

                                </Form.Item>


                            </div>


                        </div></>

                }


                <div className="details-item mandatory">

                    <div className="caption">Coupon Code <div className="red">*</div></div>
                    <div className="input-item ">
                        <Form.Item
                            initialValue={couponCodeBooked ? couponCodeBooked : undefined}
                            name="couponCode"
                            rules={[
                                {
                                    required: true,
                                    message: '*Please enter coupon code',
                                },
                            ]}
                        >
                            <input
                                placeholder='Enter Coupon Code'
                                className='input'
                                // style={{ "width": "100%" }}
                                type="text"
                                name="couponCode"
                                id="couponCode"
                                onChange={(e) => {

                                    setCouponCode(e.target.value)
                                    setIsCouponVerified(false)
                                    setCouponStatus(null)

                                    if ((couponCodeBooked && couponCodeBooked == e.target.value)) {
                                        setCouponChanged(false)
                                    }
                                    else {
                                        setCouponChanged(true)
                                    }


                                }}
                            />

                        </Form.Item>

                    </div>

                    {/* {//console.log("couponCode", couponCode)}
                    {//console.log("couponStatus", couponStatus)} */}

                    {/* //Loader for coupon verifiying........................ */}
                    {/* {
                        isCouponVerifiying && <div className="couponerror">
                        <PulseLoader color='#0a8ce0' size={9} />
                        </div>
    
                    } */}
                    {renderCoupon()}



                </div>

                <div className="details-item top">

                    <div className="caption">Upload Reports</div>
                    <div className="input-item">
                        <ReportsUploader />
                    </div>


                </div>

                <div className="button-container">

                    <button disabled={!isCouponCodeVerified()}
                        className='submt-btn' type='submit' onClick={() => handleSubmit()}>ADD/REVIEW MEDICAL HISTORY</button>

                    {
                        !isScheduled() &&
                        <button
                            className='join-btn'
                            type='submit'
                            disabled={!isCouponCodeVerified()}
                            onClick={() => { setButtonClicked("Join") }}
                        // onClick={() => { JoinNow() }}
                        >JOIN CONSULTATION</button>
                        // :
                        // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                    }
                    {
                        isScheduled() &&
                        <button type='submit' disabled={isBookAppointmentDisabled()} className='join-btn' onClick={bookappointment}>BOOK APPOINTMENT</button>
                        // :
                        // <button disabled={!isCouponCodeVerified()} className='join-btn' onClick={() => setButtonClicked("Book")}>BOOK APPOINTMENT</button>
                    }

                </div>



            </Form>


            {/* <div className="details-item mandatory">

                <div className="caption2"> <span className="red">*</span>  Mandatory</div>
                <div className="input-item ">
                   
                </div>


            </div> */}


        </div>
    )
}

export default ChooseDoctor
